import { useState, useEffect } from "react";
import ModalBackground from "../../../components/utilities/modal/ModalBackground";

const TermsAgreement = ({ onChange }) => {
    const [showTerms, setShowTerms] = useState(false);
    const [termsContent, setTermsContent] = useState("");
    const [isChecked, setIsChecked] = useState(false);

    const openTerms = () => {
        fetch('/ServiceAgreement.html')
            .then(response => response.text())
            .then(data => {
                setTermsContent(data);
                setShowTerms(true);
            })
            .catch(error => console.error("Error loading terms:", error));
    };

    return (
        <div>
            {/* Checkbox and Label */}
            <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "15px" }}>
            <input id="agreement"  type="checkbox" checked={isChecked}
            onChange={(event) => {
        	const checked = event.target.checked;
                setIsChecked(checked); // Update local state
                if (onChange) {
                    onChange(checked); // ✅ Pass boolean value instead of event
                }
            }} 
        />

                <label
                    style={{ fontSize: "16px", cursor: "pointer", textDecoration: "underline", color: "#774CF3" }}
                    onClick={openTerms}
                >
                    I accept the Terms
                </label>
            </div>

            {/* Modal */}
            {showTerms && (
                <ModalBackground>
                <div style={{ 
                    background: "white", 
                    padding: "20px", 
                    borderRadius: "10px", 
                    width: "80%",  // Increased width
                    maxWidth: "900px",  // Allow up to 900px width for larger screens
                    maxHeight: "80vh",  // Prevents modal from being too tall
                    overflowY: "auto",  // Enables scrolling when needed
                    position: "fixed", 
                    top: "50%", 
                    left: "50%", 
                    transform: "translate(-50%, -50%)"  // Centers modal
                }}>
                        
                        <div dangerouslySetInnerHTML={{ __html: termsContent }} />
                        <button
                            onClick={() => setShowTerms(false)}
                            style={{ marginTop: "10px", background: "#774CF3", color: "white", padding: "10px 20px", borderRadius: "5px" }}
                        >
                            Close
                        </button>
                    </div>
                </ModalBackground>
            )}
        </div>
    );
};

export default TermsAgreement;
